import gql from 'graphql-tag'
export default gql`query sieveSizesQuery {
  sieveSizes {
    code
    size
    id
  }
}`